import { render, staticRenderFns } from "./AnchorReportLayoutIndex.vue?vue&type=template&id=77df607d&scoped=true"
import script from "./AnchorReportLayoutIndex.vue?vue&type=script&lang=js"
export * from "./AnchorReportLayoutIndex.vue?vue&type=script&lang=js"
import style0 from "./AnchorReportLayoutIndex.vue?vue&type=style&index=0&id=77df607d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77df607d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77df607d')) {
      api.createRecord('77df607d', component.options)
    } else {
      api.reload('77df607d', component.options)
    }
    module.hot.accept("./AnchorReportLayoutIndex.vue?vue&type=template&id=77df607d&scoped=true", function () {
      api.rerender('77df607d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/layout/AnchorReportLayoutIndex.vue"
export default component.exports